import React, { useState } from "react";

import images from "@/utils/images";
import { isAuthorized } from "@/utils/authToken";

import { useCallTimer } from "../hooks/useCallTimer";

import { AllowAVStep } from "./(steps)/AllowAVStep";
import { PatientInRoomStep } from "./(steps)/PatientInRoomStep";
import { PreviewStep } from "./(steps)/PreviewStep";
import ProviderMessageStep from "./(steps)/ProviderMessageStep";
import ProviderVideoWorkflow from "./(steps)/ProviderVideoWorkflowStep";
import QuestionsStep from "./(steps)/QuestionsStep";
import ReconnectStep from "./(steps)/ReconnectStep";

import "./GuidedVideoCall.styles.scss";

export function CallStepRouter(props) {
  const { localTracks, startTime } = props;

  let [audioOff, setAudioOff] = useState(false);
  let [videoOff, setVideoOff] = useState(false);
  let [remainingTimeLeft, _setRemainingTimeLeft] = useState();
  const timer = useCallTimer(startTime.valueOf());

  const toggleTrackType = (trackType) => {
    const track = localTracks.find((track) => track.kind === trackType);

    if (track.isEnabled) {
      track.disable();
    } else {
      track.enable();
    }

    if (trackType === "audio") {
      setAudioOff(!track.isEnabled);
    } else {
      setVideoOff(!track.isEnabled);
    }
  };

  let toggleAudioBtn = (
    <button className="GuidedVideoCall__controls-btn">
      <img
        alt="audioToggle"
        className="mx-3 d-block cursor"
        onClick={() => toggleTrackType("audio")}
        src={audioOff ? images("./icons/audio_off.svg") : images("./common/mic.svg")}
      />
    </button>
  );

  let toggleVideoBtn = (
    <button className="GuidedVideoCall__controls-btn">
      <img
        alt="videoToggle"
        className="mx-3 d-block cursor"
        onClick={() => toggleTrackType("video")}
        src={videoOff ? images("./icons/video_off.svg") : images("./common/video.svg")}
      />
    </button>
  );

  const stepRouterProps = {
    ...props,
    remainingTimeLeft,
    setAudioOff,
    setVideoOff,
    timer,
    toggleAudioBtn,
    toggleVideoBtn,
  };

  if (isAuthorized("user:patient")) {
    return <PatientStepRouter {...stepRouterProps} />;
  }

  return <ProviderStepRouter {...stepRouterProps} />;
}

function PatientStepRouter(props) {
  const { callDetails, setStep, startCall, step } = props;

  switch (step) {
    case "ALLOW_AV": {
      return <AllowAVStep {...props} />;
    }

    case "PREVIEW": {
      return (
        <PreviewStep
          {...props}
          isPatient={true}
          startWorkflow={() => {
            if (!callDetails.patient_question_sets) {
              setStep("QUESTIONS");
            } else {
              startCall();
            }
          }}
        />
      );
    }

    case "QUESTIONS": {
      return <QuestionsStep callDetails={callDetails} startCall={startCall} />;
    }

    case "IN_ROOM": {
      return <PatientInRoomStep {...props} />;
    }

    case "PROVIDER_MESSAGE_STEP": {
      return <ProviderMessageStep {...props} />;
    }

    case "RECONNECT":
      return <ReconnectStep {...props} />;
  }
}

function ProviderStepRouter(props) {
  const { setStep, step } = props;

  switch (step) {
    case "ALLOW_AV": {
      return <AllowAVStep {...props} />;
    }

    case "PREVIEW": {
      return <PreviewStep {...props} isPatient={false} startWorkflow={() => setStep("IN_ROOM")} />;
    }

    case "IN_ROOM": {
      return <ProviderVideoWorkflow {...props} />;
    }
  }
}
